import { render, staticRenderFns } from "./ExternalIdsTable.vue?vue&type=template&id=2b5ae8dd&scoped=true&"
import script from "./ExternalIdsTable.vue?vue&type=script&lang=js&"
export * from "./ExternalIdsTable.vue?vue&type=script&lang=js&"
import style0 from "./ExternalIdsTable.vue?vue&type=style&index=0&id=2b5ae8dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5ae8dd",
  null
  
)

export default component.exports